import document from './document'

export  { document }